import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { styled } from '../../Stitches';
import EditorContext from './EditorContext';

const ComposerGrid = styled('div', {
  width: '100%',
  display: 'grid',
  gridGap: '12px',
  variants: {
    sideCar: {
      true: { gridTemplateColumns: '1fr 1fr' },
      false: { gridTemplateColumns: '1fr' },
    },
  },
});

export const EditorGrid = ({ children }: { children: React.ReactNode }) => {
  const { letterId } = useContextSelector(EditorContext, (ctx) => ctx.sideCar);

  return <ComposerGrid sideCar={!!letterId}>{children}</ComposerGrid>;
};
